import { createContext } from "react"

export const ElearningContext = createContext<Map<number, Window>>(new Map())
